import { render, staticRenderFns } from "./CampRelations.vue?vue&type=template&id=24e2ef15&scoped=true&"
import script from "./CampRelations.vue?vue&type=script&lang=js&"
export * from "./CampRelations.vue?vue&type=script&lang=js&"
import style0 from "./CampRelations.vue?vue&type=style&index=0&id=24e2ef15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2ef15",
  null
  
)

export default component.exports